import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { axiosGetData } from "@shared/api/clients";
import { Tenant } from "./Tenants.types";
import { AxiosError } from "axios";

export const getTenants = async (): Promise<Tenant[]> => {
  const response = await axiosGetData<Tenant[]>("v1/auth/tenants");
  return response;
};

export const useTenantsQuery = () => {
  const query = useQuery<Tenant[], AxiosError>({
    queryKey: ["tenants"],
    queryFn: getTenants,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      localStorage.setItem("isLogged", "true");
    }
  }, [query.isSuccess, query.data]);

  return query;
};
